import Vue from 'vue'
import Router from 'vue-router'
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  base: '/web/',
  routes: [

    //================================== 登录
    {
      name: 'Login',
      path: '/login',
      component: () => import('../views/login/Login'),
      meta: {
        title: '登录',
        requireLogin: false
      }
    },
    {
      name: 'Reg',
      path: '/reg',
      component: () => import('../views/login/Reg'),
      meta: {
        title: '注册',
        requireLogin: false
      }
    },
    {
      name: 'SSO',
      path: '/sso',
      component: () => import('../views/login/Sso'),
      meta: {
        title: '',//SSO
      }
    },
    //================================== 首页
    {
      name: 'Index',
      path: '/',
      component: () => import('../views/index/Index'),
      meta: {
        title: '首页',
        requireLogin: false,
      }
    },
    {
      name: 'Help',
      path: '/Help',
      component: () => import('../views/index/Help'),
      meta: {
        title: '帮助中心',
        requireLogin: false,
      }
    },
    {
      name: 'IframeView',
      path: '/IframeView',
      component: () => import('../views/index/IframeView'),
      meta: {
        title: 'Qrcode',
        requireLogin: false,
      }
    },

    // ==================  车辆操作
    {
      name: 'MyloveCar',
      path: '/MyloveCar',
      component: () => import('../views/mycar/MyloveCar'),
      meta: {
        title: '我的爱车',
        requireLogin: true,
        keepAlive: false,
      }
    },
    {
      name: 'AddCar',
      path: '/AddCar',
      component: () => import('../views/mycar/AddCar'),
      meta: {
        title: '新增车辆',
        requireLogin: true,
      }
    },
    {
      name: 'AddOtherCar',
      path: '/AddOtherCar',
      component: () => import('../views/mycar/AddOtherCar'),
      meta: {
        title: '新增爱车入口',
        requireLogin: true,
      }
    },
    {
      name: 'LookupCar',
      path: '/LookupCar',
      component: () => import('../views/mycar/LookupCar'),
      meta: {
        title: '查询车辆',
        requireLogin: true,
      }
    },
    {
      name: 'AcceptCar',
      path: '/AcceptCar',
      component: () => import('../views/mycar/AcceptCar'),
      meta: {
        title: '接收爱车',
        requireLogin: true,
      }
    },
    {
      name: 'TransferCar',
      path: '/TransferCar',
      component: () => import('../views/mycar/TransferCar'),
      meta: {
        title: '转让爱车',
        requireLogin: true,
      }
    },
    {
      name: 'UnbindBike',
      path: '/UnbindBike',
      component: () => import('../views/mycar/UnbindBike'),
      meta: {
        title: '解除绑定',
        requireLogin: true,
      }
    },
    {
      name: 'CarView',
      path: '/CarView',
      component: () => import('../views/mycar/CarView'),
      meta: {
        title: '车辆详情',
        requireLogin: false,
      }
    },
    {
      name: 'TyreView',
      path: '/TyreView',
      component: () => import('../views/mycar/TyreView'),
      meta: {
        title: '轮胎详情',
        requireLogin: true,
      }
    },
    {
      name: 'ElectronCard',
      path: '/ElectronCard',
      component: () => import('../views/mycar/ElectronCard'),
      meta: {
        title: '电子保卡',
        requireLogin: true,
      }
    },
    {
      name: 'PolicyView',
      path: '/PolicyView',
      component: () => import('../views/mycar/PolicyView'),
      meta: {
        title: '保单信息',
        requireLogin: true,
      }
    },
    {
      name: 'MaintainInfo',
      path: '/MaintainInfo',
      component: () => import('../views/mycar/MaintainInfo'),
      meta: {
        title: '保养记录',
        requireLogin: true,
      }
    },
    {
      name: 'LuckdrawList',
      path: '/LuckdrawList',
      component: () => import('../views/mycar/LuckdrawList'),
      meta: {
        title: '抽奖记录',
        requireLogin: true,
      }
    },
    {
      name: 'CarLoss',
      path: '/CarLoss',
      component: () => import('../views/mycar/CarLoss'),
      meta: {
        title: '车辆挂失',
        requireLogin: true,
      }
    },
    {
      name: 'ReportLoss',
      path: '/ReportLoss',
      component: () => import('../views/mycar/ReportLoss'),
      meta: {
        title: '挂失找回',
        requireLogin: false,
      }
    },
    {
      name: 'serviceCar',
      path: '/serviceCar',
      component: () => import('../views/mycar/serviceCar'),
      meta: {
        title: '服务评价',
        requireLogin: true,
      }
    },
    {
      name: 'DrawView',
      path: '/DrawView',
      component: () => import('../views/mycar/DrawView'),
      meta: {
        title: '活动信息填写',
        requireLogin: true,
      }
    },

    // ====================  个人中心
    {
      name: 'Me',
      path: '/Me',
      component: () => import('../views/me/Me'),
      meta: {
        title: '个人中心',
        requireLogin: true,
      }
    },
    {
      name: 'myprofile',
      path: '/myprofile',
      component: () => import('../views/me/myprofile'),
      meta: {
        title: '修改个人资料',
        requireLogin: true,
      }
    },
    {
      name: 'userInfo',
      path: '/userInfo',
      component: () => import('../views/me/userInfo'),
      meta: {
        title: '完善用户信息',
        requireLogin: true,
      }
    },
    
    //================================== 其他
    {
      path: '*',
      redirect: '/'
    },

  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if( to.hash ){
        return {
          selector: to.hash
        }
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js